import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { getCurrentUser } from "./login";
import { ADDRESS_COLLECTION, CLIENTS_COLLECTION, ENTERPRISES_COLLECTION } from "../constants/collections";
import { ENTERPRISE_DOC_ID } from "../constants/configs";

const getCorrespondents = async (data) => {
  const user = getCurrentUser();
  const q = query(collection(db, ENTERPRISES_COLLECTION, ENTERPRISE_DOC_ID, CLIENTS_COLLECTION), where("userId", "==", user.uid))
  const querySnapshot = await getDocs(q);
  return  querySnapshot.docs.map((doc) => doc.data())
}

const getCorrespondentAddress = async (clientId) => {
  const user = getCurrentUser();
  const ref = query(
    collection(db, ENTERPRISES_COLLECTION, ENTERPRISE_DOC_ID, ADDRESS_COLLECTION),
    where('idClient', '==', clientId)
  );
  const querySnapshot = await getDocs(ref);
  return  querySnapshot.docs.map((doc) => doc.data());
};


export {
  getCorrespondents,
  getCorrespondentAddress
}